import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto p-5" }
const _hoisted_2 = { class: "grid grid-cols-1" }
const _hoisted_3 = {
  key: 0,
  class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 mt-1 py-[16px]"
}
const _hoisted_5 = { class: "flex justify-between items-center pt-2 mb-8" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "flex gap-3 flex-col items-start mb-3" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "flex items-center cursor-pointer w-[100px]" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = ["textContent"]
const _hoisted_14 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_editor = _resolveComponent("editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.vg_selectedLocation.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_block_loading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-white font-semibold text-[24px]" }, "Message Banner", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.save()), ["prevent"])),
                      disabled: !_ctx.form.headerTitle.value || !_ctx.form.headerMessage.value || !_ctx.validLength,
                      class: "bg-white text-theme-green rounded mt-2 px-4 py-2 hover:bg-theme-darkgreen hover:text-white disabled:bg-theme-grey disabled:text-grey"
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("span", { class: "text-sm tracking-widest font-medium" }, "SAVE", -1)
                    ]))], 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.displayHeaderMessage) = $event)),
                          class: "hidden peer"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.form.displayHeaderMessage]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.displayHeaderMessage ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                        }, null, 2),
                        _createElementVNode("span", {
                          class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.displayHeaderMessage ? 'text-theme-green' : 'text-[#F53333]'])
                        }, _toDisplayString(_ctx.form.displayHeaderMessage ? 'ON' : 'OFF'), 3)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass('input-wrapper ' + (_ctx.form.headerTitle.error_type))
                      }, [
                        _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs mb-1 font-normal" }, "Header", -1)),
                        _withDirectives(_createElementVNode("input", {
                          placeholder: "",
                          maxlength: "100",
                          onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateFields(['headerTitle']))),
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.headerTitle.value) = $event)),
                          type: "text",
                          class: "block rounded bg-gray-black border-none w-full text-sm text-theme-white"
                        }, null, 544), [
                          [_vModelText, _ctx.form.headerTitle.value]
                        ]),
                        (_ctx.form.headerTitle.error_message)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: "field-error label-text mt-1",
                              textContent: _toDisplayString(_ctx.form.headerTitle.error_message)
                            }, null, 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", {
                        class: _normalizeClass('input-wrapper' + (_ctx.form.headerMessage.error_type))
                      }, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs mb-1 font-normal" }, "Body", -1)),
                        _createVNode(_component_editor, {
                          modelValue: _ctx.form.headerMessage.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.headerMessage.value) = $event)),
                          "api-key": "g9cb9qbrbpojjpn14jkz7wzm70e222rsiaov5xfa0170aerh",
                          init: {
                                menubar: false,
                                plugins: 'lists link wordcount',
                                toolbar: 'styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image emoticons',
                                skin: 'oxide-dark',
                                content_css: 'dark',
                              },
                          onKeyup: _ctx.editorChange
                        }, null, 8, ["modelValue", "onKeyup"]),
                        (_ctx.form.headerMessage.error_message)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: "field-error label-text mt-1",
                              textContent: _toDisplayString(_ctx.form.headerMessage.error_message)
                            }, null, 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ], 2)
                    ])
                  ])
                ]))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.", -1)
          ]))]))
    ])
  ]))
}